import { AppEmbed, EmbedEvent, MessagePayload, Page } from '@thoughtspot/visual-embed-sdk'
import { useEffect } from 'react'
import { logError } from '../../services/error/logger'
import EmbeddedContent from '../../components/EmbeddedContent'
import { COMMON_THOUGHTSPOT_ACTIONS, HIDDEN_CREATE_VISUAL_ACTIONS } from '../../constants'
import { convertTsUrlToHfIntelligenceUrl } from '../../services/route/tsHfIntelligenceUrlMapper'
import { useNavigate } from 'react-router-dom'
import type { IMessagePayload } from '../../types'

export const embedId = 'embed-visualisations'

/**
 * Visualisations page accessible by the URL: /visualisations
 * This page matches the Thoughtspot 'Answers' page under Insights
 */

const Visualisations = () => {
  const navigate = useNavigate()
  
  useEffect(() => {
    const appEmbed = new AppEmbed(`#${embedId}`, {
      pageId: Page.Answers,
      hiddenActions: HIDDEN_CREATE_VISUAL_ACTIONS,
      ...COMMON_THOUGHTSPOT_ACTIONS
    })

    void appEmbed
    .on(EmbedEvent.Error, (messagePayload: MessagePayload) => {
      const embedError = new Error(
        `Visualisations: ${JSON.stringify(messagePayload)}`,
      )
      logError(embedError)
    })
    .on(EmbedEvent.RouteChange, (messagePayload: IMessagePayload) => {
      const route = messagePayload.data.currentPath
      const visualisationUrl = convertTsUrlToHfIntelligenceUrl(route)
      navigate(visualisationUrl)
    })
    .render()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <EmbeddedContent
      id={embedId}
      testId={embedId}
    />
  )
}

export default Visualisations
